module.exports = __webpack_public_path__ + "static/domview-ab89621bbf6f5e39d0d032f4d98089e7.png";